import React from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore } from '@pascal/pascal-core';

import BetSection from '../../components/betSection';
import AmountSection from '../../components/amountSection';
import AutoBetSection from '../../components/autoBetSection';
import TurboModeSection from '../../components/turboModeSection';
import { gameStore } from '../../store/gameStore';

const BetSectionWrapper = observer(() => {
  const { isTurboModeExist } = gameStore;
  const { gameConfiguration = {} } = gameConfigStore;
  const { autobet: isAutoBetConfigEnabled } = gameConfiguration;

  return (
    <div className='action-btn-group'>
      <div className={`action-btn-row ${isTurboModeExist ? '' : 'j-c-s-a'}`}>
        <AmountSection />
        {isAutoBetConfigEnabled && <AutoBetSection />}
        {isTurboModeExist && <TurboModeSection />}
      </div>
      <BetSection />
    </div>
  );
});

export default BetSectionWrapper;
